define('bizzabo/models/Tier',['bizzabo/models/SyncedModel', 'bizzabo/models/ValidationObject'], function(SyncedModel, ValidationObject) {

    var Tier = SyncedModel.extend({

        validationObject : undefined,

        initialize : function() {
            this.validationObject = new ValidationObject(this);
        },

        validation : {
            label : [
                {
                    required : true,
                    msg : 'Label is required'
                },
                {
                    maxLength : 35,
                    msg : 'Label too long'
                }
            ],
            color : {
                required : true,
                msg : 'Color is required'
            }
        }
    });

    return Tier;

});
